export default {
  title: {
    candidateIndexPage: 'Job Seekers',
    indexPage: 'Recruiting Solutions',
    intelligencePage: 'AJINGA Intelligence',
    login: 'Login',
    register: 'Register',
    forgetPassword: 'Forgot Password?',
    resetPassword: 'Reset Password',
    createPassword: 'Create Password',
    '51job': '51 Job',
    jobStreet: 'Job Street',
    emailDialog: 'The following email(s) from your prior activity are associated with your mobile phone number. Please select an email and click "Use This Account" to continue, or click "Create New Account". ',
    registerWithAjinga: 'Register With AJINGA',
    companyRegister: 'Company Register'
  },
  label: {
    loginOtherAccount: 'Login with Other Account',
    otherAccount: {
      '51job': '51 Job',
      facebook: 'Facebook',
      linkedin: 'LinkedIn',
      jobStreet: 'Job Street'
    },
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Mobile Number',
    verifyCode: 'Code',
    chinesePhone: 'Mainland China mobile number',
    smsCode: 'SMS Code',
    captcha: 'Code',
    resendVerifyCode: 'Resend ({countdown})',
    employeeRegister: {
      registerCompany: 'Company',
      name: 'Name',
      email: 'Email',
      employeeGroupIdNum: 'Group ID Number',
      employeeIdNum: 'Employee ID',
      phone: 'Phone',
      password: 'Password',
      authInfo: 'Validation Info',
      pinCode: 'Company Pin'
    },
    register: 'Register/Login',
    passwordLogin: 'Password Login',
    lastLoginTime: ' (Last used on: {time})'
  },
  placeholder: {
    email: 'Please enter email',
    emailOrPhone: 'Please enter email/mobile',
    password: 'Please enter your password',
    createPassword: 'Please create your password',
    employeeNumber: 'Please enter your employee ID',
    customEmployeeNumber: 'Please enter your {customTip}',
    firstName: 'Please enter your first name',
    lastName: 'Please enter your last name',
    phone: 'Please enter mobile number',
    verifyCode: 'Please enter verification code',
    pleaseEnter: 'Please enter {placeholder}',
    chinesePhone: 'Please enter mainland China mobile number',
    smsCode: 'Please enter verification code',
    captcha: 'Please enter captcha',
    confirmPassword: 'Please enter password again',
    employeeRegister: {
      registerCompany: 'Please select company',
      name: 'Please enter name',
      email: 'Please enter email',
      employeeGroupIdNum: 'Please enter group ID number',
      employeeIdNum: 'Please enter employee ID',
      phone: 'Please enter phone',
      password: 'Please enter password',
      authInfo: 'Please enter validation info',
      pinCode: 'Please enter company pin'
    },
    companyName: 'Please enter company name'
  },
  btn: {
    login: 'Login',
    forgetPassword: 'Forgot password',
    register: {
      candidate: 'Join Now',
      employee: 'Register Now'
    },
    getVerifyCode: 'Get verification code',
    resendVerifyCode: 'Resend',
    back: 'Back',
    useEmailLogin: 'Use This Account',
    continueRegister: 'Create NEW Account'
  },
  message: {
    loginCompany: 'Login',
    registerCompany: 'Register a new account',
    phoneNotChange: 'Your mobile number cannot be changed',
    updateSuccess: 'Update Success',
    loginTip: {
      hasAccount: 'Already have an account? ',
      login: 'LOGIN.',
      loginByVerifyCode: 'Login with verification code',
      loginByPassword: 'Login with password'
    },
    registerTip: {
      noAccount: 'No account yet? ',
      register: 'REGISTER a new account.',
      registerByEmail: 'Register By Email'
    },
    hrLoginTip: 'Please login with your company email address',
    policy: {
      tip: 'I certify that I have read and agree to the ',
      userAgreement: 'AJINGA User Agreement',
      privacyPolicy: 'AJINGA Privacy Policy',
      loginTip: 'Unregistered cell phone numbers will be automatically registered'
    },
    agreePolicyFirst: 'Please read and agree to the policy',
    accountOrPasswordIsWrong: 'Your username or password is incorrect',
    lockAccount: {
      lockAfter: 'Your username or password is incorrect. Please try again. Please be aware that {times} failed login attempts will result in your account being locked for 60 minutes',
      countdownTime: 'Your account has been locked, please login after {countdownTime} minutes'
    },
    getVerifyCodeFirst: 'Please get the verification code first',
    invalidVerifyCode: 'Verification code is invalid',
    passwordRule: 'Password must contain small letter, capital letter and number, and at least 10 digit, symbol can only use _#@.-',
    employeeRegisterTip: 'After you click the Register Now button, a confirmation email will be sent to your email. Please click the link in the email to activate your account within 24 hours. ',
    resetTip: {
      label: ['Retrieve password by ', 'type_link_html'],
      type: {
        email: 'email.',
        phone: 'mobile number.'
      }
    },
    notSamePassword: 'Please make sure the two passwords are the same',
    userIsNotExists: 'Account does not exist. Please contact your administrator.',
    candidateIsNotExists: 'Account is not exists, please check it',
    resetPasswordSuccess: 'Reset password success!',
    createPasswordSuccess: 'Password created successfully.',
    passwordSameAsPrevious: 'Your new password must be different from the previous one',
    sentResetPasswordEmail: 'A password reset email has been sent to your email inbox from service@mail.ajinga.com. Please click the link in the email within the next 24 hours, to reset your password.',
    bindEmailRequired: 'Please select your e-mail address'
  },
  accountType: {
    AGENCY: 'Agency',
    HR: 'Recruiter',
    HIRING_MANAGER: 'Hiring Manager',
    EMPLOYEE: 'Employee',
    CANDIDATE: 'Job Seekers',
    ALUMNI: 'Alumni'
  }
}
